"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=require("./index96.js");var t=o.symbolConstructorDetection,e=t&&!Symbol.sham&&typeof Symbol.iterator=="symbol";exports.useSymbolAsUid=e;
